import { SET_PERMISSIONINFO } from './mutation-type';

export default {
    [SET_PERMISSIONINFO](state, data) {
        state.permissionCode = data;
    },
    // 侧边菜单栏是否展开
    expandMuneOperation(state, data) {
        state.expandMuneBoolen = data;
    },
    setPadding(state, data) {
        state.noPadding = data;
    },
    resetPadding(state, data) {
        state.paddingValue = data;
    },
    setFixPadding(state, data) {
        state.fixPadding = data;
    },
};
